import MilkMoovement from "./MilkMoovement.png";
import Cargill from "./Cargill.png";
import Vendor from "./Vendor.png";

const logos: { [name: string]: string } = { MilkMoovement, Cargill, Vendor };

export const getLogo = (name: string) => logos[name] || Vendor;

export default logos;
